/**
 * Autogenerated file.
 * For adding or changing icons, see README.MD
 */
import React from 'react';
import { createIcon } from '../../icon/create-icon'; // Outline

const XOutline = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m18.75 5.25-13.5 13.5m13.5 0L5.25 5.25"
})); // Fill


const XFill = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  fill: "var(--i-color)",
  d: "m13.06 11.98 6.22-6.21c.12-.15.18-.34.18-.52a.732.732 0 0 0-.23-.5.732.732 0 0 0-.5-.23c-.18 0-.37.06-.51.18L12 10.92 5.78 4.7a.795.795 0 0 0-.51-.18c-.19.01-.37.09-.5.23-.14.13-.22.31-.23.5-.01.18.06.37.18.52l6.22 6.21-6.22 6.22c-.15.14-.22.33-.22.53s.07.39.22.54c.14.13.33.21.53.21s.39-.08.53-.21L12 13.04l6.22 6.23c.14.13.33.21.53.21s.39-.08.53-.21c.15-.15.22-.34.22-.54s-.07-.39-.22-.53l-6.22-6.22z"
})); // DuoTone


const XDuotone = props => /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("path", {
  stroke: "var(--i-color)",
  strokeLinecap: props.strokeLinecap,
  strokeLinejoin: props.strokeLinejoin,
  strokeWidth: "var(--i-s-width)",
  d: "m18.75 5.25-13.5 13.5m13.5 0L5.25 5.25"
}));
/**
  Icon XIcon in math group
*/


export const XIcon = createIcon('XIcon', 'x', 'math', XOutline, XFill, XDuotone, "0 0 24 24");